import { RadioGroup } from "radix-ui";
import type { PropsWithChildren } from "react";
import { type Control, Controller, type FieldValues, type Path } from "react-hook-form";
import { RadioGridItem } from "./radio-grid-item";

/** Props Interface */
interface RadioGridProps<T extends FieldValues> extends PropsWithChildren {
	control: Control<T>;
	name: Path<T>;
}

function RadioGrid<T extends FieldValues>({ children, control, name }: RadioGridProps<T>) {
	/** Render */
	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => (
				<RadioGroup.Root
					className="grid grid-rows-auto gap-y-4"
					onValueChange={field.onChange}
					value={field.value}
				>
					{children}
				</RadioGroup.Root>
			)}
		/>
	);
}

RadioGrid.Item = RadioGridItem;

export { RadioGrid };
